export default {
  SET_PINS(state, pins) {
    state.pins = pins;
  },
  SET_PINS_PROPOSITION_ID(state, id) {
    state.pinsPropositionId = id;
  },
  SET_LOADING_PINS(state, loading) {
    state.loadingPins = loading;
  },
  SET_SELECTED_PIN_ID(state, id) {
    state.selectedPinId = id;
  },
  SET_HOVERED_PROPOSITION_ID(state, id) {
    state.hoveredPropositionId = id;
  },
  SET_SELECTED_SUGGESTION(state, suggestion) {
    state.selectedSuggestion = suggestion;
  },
  SET_LOADING_SUGGESTION(state, loading) {
    state.loadingSuggestion = loading;
  },
  SET_SELECTED_SUGGESTIONS(state, suggestions) {
    state.selectedSuggestions = suggestions;
  },
  SET_SUGGESTION_AT_INDEX(state, { index, suggestion }) {
    state.selectedSuggestions.splice(index, 1, suggestion);
  },
  CACHE_SUGGESTION(state, { id, suggestion }) {
    state.suggestionCache = { ...state.suggestionCache, [id]: suggestion };
  },
  CLEAR_SUGGESTION_CACHE(state) {
    state.suggestionCache = {};
  },

  UPDATE_INTEREST_STATE(state, { propositionId, interested }) {
    const id = propositionId.toString();

    const cached = state.suggestionCache[id];
    if (cached) {
      cached.details.interests.splice(0, 1, interested);
    }

    if (state.selectedSuggestion?.propositionId?.toString() === id) {
      state.selectedSuggestion.details.interests.splice(0, 1, interested);
      state.selectedSuggestion = { ...state.selectedSuggestion };
    }

    const idx = state.selectedSuggestions.findIndex(
      s => s.propositionId?.toString() === id
    );
    // Pending lazy placeholders have no details yet.
    if (idx !== -1 && state.selectedSuggestions[idx].details) {
      state.selectedSuggestions[idx].details.interests.splice(0, 1, interested);
      state.selectedSuggestions.splice(idx, 1, {
        ...state.selectedSuggestions[idx]
      });
    }
  }
};
